import { ORDERS_TABLE_TABS, Filter, Operators, ORDERS_SEARCH_OPTIONS_LS } from "../constants";

export const getOrdersSearchFilters = (activeOrdersTabId) => {
  // Unpicked orders
  if (activeOrdersTabId === ORDERS_TABLE_TABS.UN_PICKED.value) {
    const unpickedOrdersFilters: Filter[] = [
      { field: "pickingStatus", operator: Operators.EQ, value: "Unpicked" },
      { field: "shippingStatus", operator: Operators.IN, value: ["ReadyToPrint", "Unshipped", "Error"] },
      { field: "issueStatus", operator: Operators.EQ, value: "NoIssue" },
    ];

    return unpickedOrdersFilters;
  }
  // Assigned orders
  if (activeOrdersTabId === ORDERS_TABLE_TABS.ASSIGNED.value) {
    const assignedOrdersFilters: Filter[] = [
      { field: "userId", operator: Operators.NE, value: "" },
      { field: "shippingStatus", operator: Operators.IN, value: ["ReadyToPrint", "Unshipped", "Error"] },
      { field: "issueStatus", operator: Operators.EQ, value: "NoIssue" },
      { field: "pickingStatus", operator: Operators.EQ, value: "Unpicked" },
    ];

    return assignedOrdersFilters;
  }
  // Error orders
  if (activeOrdersTabId === ORDERS_TABLE_TABS.ERROR.value) {
    const errorOrdersFilters: Filter[] = [
      { field: "shippingStatus", operator: Operators.EQ, value: "Error" },
      { field: "issueStatus", operator: Operators.EQ, value: "NoIssue" },
    ];

    return errorOrdersFilters;
  }
  // Issues orders
  if (activeOrdersTabId === ORDERS_TABLE_TABS.ISSUES.value) {
    const issuesOrdersFilters: Filter[] = [
      { field: "issueStatus", operator: Operators.EQ, value: "Issue" },
      { field: "shippingStatus", operator: Operators.IN, value: ["ReadyToPrint", "Unshipped", "Error"] },
    ];

    return issuesOrdersFilters;
  }
  // On hold orders
  if (activeOrdersTabId === ORDERS_TABLE_TABS.ON_HOLD.value) {
    const onHoldOrders: Filter[] = [
      { field: "issueStatus", operator: Operators.EQ, value: "OnHold" },
      { field: "shippingStatus", operator: Operators.IN, value: ["ReadyToPrint", "Unshipped", "Error"] },
    ];

    return onHoldOrders;
  }
  // Cancelled orders
  if (activeOrdersTabId === ORDERS_TABLE_TABS.CANCELLED.value) {
    const cancelledOrders: Filter[] = [{ field: "shippingStatus", operator: Operators.EQ, value: "Cancelled" }];

    return cancelledOrders;
  }

  return;
};
